<template>
  <div class="container">
    <table-of-members></table-of-members>
  </div>
</template>

<script>
import TableOfMembers from "@/views/main/TableOfMembers.vue";
export default {
components: {TableOfMembers}
};
</script>

<style scoped>

</style>